import React from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { useForm, Controller } from "react-hook-form";

import imgelcamino from "assets/image/elcamino-white.png";
import Loader from "components/Loader";

import "./styles.css";

const Login = ({ onSubmit }) => {
  const { handleSubmit, control } = useForm();
  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="8">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleSubmit(onSubmit)}>
                    <h1>Iniciar sesión</h1>
                    <CInputGroup className="mb-3">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-user" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Controller
                        as={CInput}
                        type="text"
                        placeholder="Correo electrónico"
                        autoComplete="email"
                        name="email"
                        required
                        control={control}
                        defaultValue=""
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-lock-locked" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Controller
                        as={CInput}
                        type="password"
                        placeholder="Contraseña"
                        name="password"
                        required
                        control={control}
                        defaultValue=""
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs="6">
                        <CButton color="dark" type="submit" className="px-4">
                          Ingresar
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard
                className="py-5 d-md-down-none card-image"
                style={{ width: "44%" }}
              >
                <CCardBody className="text-center card-body-image">
                  <img
                    src={imgelcamino}
                    alt="El Camino"
                    className="image-elcamino"
                  />
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Loader((props) => props.loading)(Login);
